import VueRouter from "vue-router";
import SearchResults from "./../components/app/products/searchResults.vue";
import Department from "./../components/app/products/department.vue";
import ProductDetail from "./../components/app/products/productDetail.vue";
import Home from "./../components/app/home.vue";
import Contact from "./../components/app/contact.vue";
import VPD from "./../components/app/help/vpd";

// setup routes
const routes = [
    { path: '/', name: 'home', component: Home },
    { path: '/about/', name: 'about', component: Home },
    { path: '/reserve/', name: 'reserve-collection', component: Home },
    { path: '/checkout/', name: 'checkout', component: Home },
    { path: '/contact/', name: 'contact', component: Contact },
    { path: '/payments-privacy-terms/', name:'payments-privacy-terms', component: Home },
    { path: '/shop/', name: 'shop-home', redirect: '/shop/lighting' },
    { path: '/shop/search', name: 'search', component: SearchResults },
    { path: '/shop/product/:productSlug', name: "product-detail", component: ProductDetail },
    { path: '/help/vpd', name: "vpd", component: VPD },
    { path: '/shop/:departmentSlug', name: "department", component: Department },
];

const router = new VueRouter( {
    mode:'history',
    history: true,
    saveScrollPosition: true,
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
    root: '',
    routes, // short for routes: routes
} );

export default router;